/**
 * 充币 提币 快捷币种选择
 */

import React from 'react';

import { Create } from '_src/common/utils/Views';
import TipMessage from '_common/components/TipMessage/TipMessage';
import CurrencySelect from '_common/components/currencySelect/CurrencySelect';
import HotCoin from '_common/components/hotCoin/HotCoin';
import BalanceContext from '_common/container/balance/BalanceContext';
import './RechargeAndWithdraw.less';

class rechargeCurrency extends BalanceContext {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderTipMessage = (message = []) => {
    return message?.map((msg, index) => {
      return <p key={index}>{msg}</p>;
    });
  };

  render() {
    const {
      selectCurrency,
      currencyList,
      hotCurrency,
      showNetwork,
      selectNetwork,
      isWithdraw,
      reminderMessage,
      showPauseTips,
    } = this.props;
    const networkList = selectCurrency
      ? selectCurrency.subCurrencies.slice()
      : [];

    const showNetworkReminder =
      isWithdraw && selectNetwork?.reminderMessage?.length > 0;

    return (
      <React.Fragment>
        <div className="form-item">
          <div className="input-title">
            {this.translate('address.dialog.selectCoin')}
          </div>
          <div className="form-input-box">
            <CurrencySelect
              list={currencyList}
              selectedObj={selectCurrency}
              changeSelectedHandle={(network) => {
                if (network !== null) {
                  this.props.updateCoin(network);
                }
              }}
              placeholder={this.translate('balance.placeholder.currency')}
              noResultsText={this.translate('operation.search.noValue')}
            />
          </div>
        </div>
        {showNetwork && networkList.length > 0 && (
          <div className="form-item">
            <div className="input-title">
              {this.translate('address.dialog.selectNetwork')}
            </div>
            <div className="form-input-box">
              <CurrencySelect
                showPauseTips={showPauseTips}
                list={networkList}
                selectedObj={selectNetwork}
                changeSelectedHandle={(network) => {
                  if (network !== null) {
                    this.props.updateNetwork(network);
                  }
                }}
                placeholder={this.translate('deposit.placeholder.network')}
                noResultsText={this.translate('operation.search.noValue')}
              />
            </div>
            {reminderMessage?.length > 0 && (
              <div className="form-item">
                <div className="input-title" />
                <div className="form-input-box">
                  <TipMessage
                    title={this.renderTipMessage(reminderMessage)}
                    type={TipMessage.type.warn}
                    closeFlag={false}
                  />
                </div>
              </div>
            )}
            <Create when={showNetworkReminder}>
              <div className="network-tip-box">
                {selectNetwork?.reminderMessage?.map((msg, index) => {
                  return (
                    <p className="network-tip" key={index}>
                      {msg}
                    </p>
                  );
                })}
              </div>
            </Create>
          </div>
        )}
        {!selectCurrency && (
          <div className="form-item">
            <div className="input-title" />
            <div className="recharge-hot-list-container">
              <HotCoin
                hotList={hotCurrency}
                changeCoin={this.props.updateCoin}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default rechargeCurrency;
